export default {
  "v2-dashboard": process.env.NODE_ENV === "production",
};
